import { Outlet } from "react-router-dom";
import { AttendancesContext } from "./config/contexts";
import { useState } from "react";
import {
  AttendanceMonth,
  AvailableMonth,
  Giustificativo,
  Version,
} from "./api/openapi";
import { AttendancesContextType, TempAttendanceMonth } from "./config/types";

export function AttendancesLayout() {
  const [attendanceMonth, setAttendanceMonth] = useState<AttendanceMonth>();
  const [tempAttendanceMonth, setTempAttendanceMonth] =
    useState<TempAttendanceMonth>();
  const [attendanceVersions, setAttendanceVersions] = useState<Version[]>();
  const [availableMonths, setAvailableMonths] = useState<AvailableMonth[]>();
  const [selectedMonth, setSelectedMonth] = useState<number>();
  const [selectedYear, setSelectedYear] = useState<number>();
  const [isSubmitted, setIsSubmitted] = useState<boolean>();
  const [submittedAt, setSubmittedAt] = useState<Date | null>();
  const [availableGiustificativi, setAvailableGiustificativi] =
    useState<Giustificativo[]>();

  const attendancesContext: AttendancesContextType = {
    attendanceMonth,
    setAttendanceMonth,
    tempAttendanceMonth,
    setTempAttendanceMonth,
    availableMonths,
    setAvailableMonths,
    attendanceVersions,
    setAttendanceVersions,
    selectedMonth,
    setSelectedMonth,
    selectedYear,
    setSelectedYear,
    isSubmitted,
    setIsSubmitted,
    submittedAt,
    setSubmittedAt,
    availableGiustificativi,
    setAvailableGiustificativi,
  };

  return (
    <AttendancesContext.Provider value={attendancesContext}>
      <Outlet />
    </AttendancesContext.Provider>
  );
}
